export interface IOverviewColumn {
    displayName: string;
    name: string;
    orderDirection?: OrderDirection;
}

export enum OrderDirection {
    asc = 'asc',
    desc = 'desc',
}
